import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';
import PrivacyPDF from '../../static/files/Politica-Privacidade-Marvel.pdf';

import {SectionProps} from '../../types/form';

const Section1 = (props: SectionProps) => {

    const {handleNext} = props;

    return (
        <Box>
            <Typography variant={'h2'}>
                Consentimento
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}}>
                Prezado(a),
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}}>
                Seus dados serão tratados para finalizar a sua inscrição no processo seletivo, analisar seu currículo e,
                se o caso, entrar em contato e dar seguimento às etapas de nosso processo. Para mais informações sobre o
                tratamento de seus dados, acesse o nosso Aviso de Privacidade.
            </Typography>
            <Typography
                download
                component={Link}
                href={PrivacyPDF}
                variant={'body1'}
                target={'_blank'}
                underline={'hover'}
                sx={{
                    mb: '20px',
                }}
            >
                Aviso de Privacidade
            </Typography>

            <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                <Button variant={'contained'} onClick={handleNext}>
                    Concordo
                    <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                </Button>
            </Stack>
        </Box>
    );
};

export default Section1;